export const SCORES_TOGGLE_SKILL = 'SCORES_TOGGLE_SKILL';
export const SET_DISCIPLINE_SCORE = 'SET_DISCIPLINE_SCORE';
